import React, { useEffect, useState } from "react";
import Text from "../../../../components/Text/Text";
import Input from "../../../../components/Input/Input";
import { SearchOutlined } from "@ant-design/icons";
import TablePagination from "../../../../components/Table/TablePagination";
import { icon } from "../../../../resource";
import { numberFormatter } from "../../../../utility/Formatter";
import { Col, Row, Space } from "antd";
import SortFieldCustom from "../../../../components/SortFieldTable/SortFieldCustom";
import type { productDetailAchieveEntity } from "../../../../entities/AchievementEntity";

interface ProductTabProps {
  data: { data: productDetailAchieveEntity[]; count: number };
  searchText?: string | undefined;
  setSearchText: (val: string | undefined) => void;
  sortField?: string;
  sortDirection?: "ASC" | "DESC";
  handleSortChange?: (field: string) => void;
  setPage: (val: number) => void;
  page?: number;
  loading: boolean;
}

function ProductTab({
  data,
  searchText,
  setSearchText,
  setPage,
  page,
  sortField,
  sortDirection,
  handleSortChange,
  loading,
}: ProductTabProps) {
  const columns: any[] = [
    {
      title: "สินค้า",
      dataIndex: "productName",
      key: "productName",
      width: "40%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src={row.productImage || icon.emptyProduct}
                style={{ width: "50px", height: "50px", objectFit: "cover", marginRight: "10px" }}
              />
              <Space direction='vertical' size={0}>
                <Text fontFamily='Sarabun'>{value}</Text>
                <Text fontFamily='Sarabun' fontSize={14} color='Text3'>
                  {row.productCommonName}
                </Text>
              </Space>
            </div>
          ),
        };
      },
    },
    {
      title: "ขนาด",
      dataIndex: "packSize",
      key: "packSize",
      width: "20%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Space direction='vertical' size={0}>
              <Text>{value}</Text>
              <Text fontFamily='Sarabun' fontSize={14} color='Text3'>
                {row.productCodeNAV}
              </Text>
            </Space>
          ),
        };
      },
    },
    {
      title: () => (
        <SortFieldCustom
          title='จำนวน'
          sortDirection={sortField === "totalQuantity" ? sortDirection : undefined}
          onSortChange={() => handleSortChange?.("totalQuantity")}
        />
      ),
      dataIndex: "totalQuantity",
      key: "totalQuantity",
      width: "20%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Space direction='vertical' size={0}>
              <Text>{numberFormatter(value, 2)}</Text>
              <Text fontFamily='Sarabun' fontSize={14} color='Text3'>
                {row.unitName}
              </Text>
            </Space>
          ),
        };
      },
    },
    {
      title: () => (
        <SortFieldCustom
          title='จำนวนเงิน'
          sortDirection={sortField === "totalAmount" ? sortDirection : undefined}
          onSortChange={() => handleSortChange?.("totalAmount")}
        />
      ),
      dataIndex: "totalAmount",
      key: "totalAmount",
      width: "20%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <Space direction='vertical' size={0}>
              <Text>{numberFormatter(value, 2)}</Text>
              <Text fontFamily='Sarabun' fontSize={14} color='Text3'>
                บาท
              </Text>
            </Space>
          ),
        };
      },
    },
  ];
  const [inputText, setInputText] = useState<string>("");
  const handleSearch = () => {
    setSearchText(inputText || undefined);
    setPage(1);
  };
  useEffect(() => {
    if (searchText === undefined) {
      setInputText("");
    }
  }, [searchText]);
  return (
    <>
      <Row justify='space-between' style={{ margin: "22px 0px" }}>
        <Col span={20}>
          <Input
            style={{ width: "25%" }}
            allowClear
            placeholder='ชื่อสินค้า'
            suffix={<SearchOutlined />}
            value={inputText}
            onPressEnter={handleSearch}
            onChange={(e) => {
              const value = e.target.value;
              setInputText(value);
              if (!value) setSearchText(undefined);
            }}
          />
        </Col>
        <Col span={4} style={{ display: "flex", justifyContent: "flex-end" }}>
          <Text fontSize={14}>ทั้งหมด {numberFormatter(data.count, 0)} รายการ</Text>
        </Col>
      </Row>

      <TablePagination
        columns={columns}
        data={data.data || []}
        isLoading={loading}
        locale={{
          emptyText: (
            <div
              style={{
                padding: 32,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 24,
                minHeight: 350,
              }}
            >
              <img
                src={icon.emptyHistoryPoint}
                style={{
                  width: 80,
                  height: 90,
                }}
                alt='empty_table'
              />
              <Text fontFamily='Sarabun' fontSize={14} fontWeight={400} color='Text3'>
                ไม่มีรายการสินค้า
              </Text>
            </div>
          ),
        }}
        pagination={{
          current: page,
          total: data?.count,
          pageSize: 10,
        }}
        onPageChange={(pageNum) => setPage?.(pageNum)}
      />
    </>
  );
}

export default ProductTab;
